import { Action, ActionReducer } from '@ngrx/store';
import { AuthState } from './auth/auth.state';
import { ContractState } from './contract/contract.state';
import { UiState } from './ui/ui.state';
import { uiReducer } from './ui';
import { authReducer } from './auth';
import { contractReducer } from './contract/contract.reducer';
import { ContractEffects } from './contract/contract.effects';
import { AircraftEffects, AircraftState, aircraftReducer } from './aircraft';
import { ServiceCenterEffects, ServiceCenterState, serviceCenterReducer } from './service-center';

export interface AppState {
  ui: UiState;
  auth: AuthState;
  contract: ContractState;
  aircraft: AircraftState;
  serviceCenter: ServiceCenterState;
}

export interface AppStore {
  ui: ActionReducer<UiState, Action>;
  auth: ActionReducer<AuthState, Action>;
  contract: ActionReducer<ContractState, Action>;
  aircraft: ActionReducer<AircraftState, Action>;
  serviceCenter: ActionReducer<ServiceCenterState, Action>;
}

export const appStore: AppStore = {
  ui: uiReducer,
  auth: authReducer,
  contract: contractReducer,
  aircraft: aircraftReducer,
  serviceCenter: serviceCenterReducer,
};

export const appEffects = [ContractEffects, AircraftEffects, ServiceCenterEffects];
